import type {MutableFilterBlock} from '@github-ui/filter-core'
import {capitalize, getFilterValue} from '@github-ui/filter-core'
import {testIdProps} from '@github-ui/test-id-props'
import {TriangleDownIcon} from '@primer/octicons-react'
import type {SelectPanelItemInput as ItemInput} from '@primer/react'
import {ActionList, ActionMenu, Button} from '@primer/react'

import styles from './BooleanValueSelect.module.css'
import {ValuePlaceholder} from './ValuePlaceholder'

interface BooleanValueSelectProps {
  index: number
  filterBlock: MutableFilterBlock
  setFilterValues: (selected: ItemInput | ItemInput[] | boolean | undefined) => void
}

const getBooleanValueLabel = (filterBlock: MutableFilterBlock, index: number): string => {
  const value = getFilterValue(filterBlock.value?.values[0]?.value)
  if (value === 'true' || value === 'false') {
    return `${capitalize(value)}, Value ${index + 1}`
  }
  return `Value ${index + 1}`
}

export const BooleanValueSelect = ({index, filterBlock, setFilterValues}: BooleanValueSelectProps) => {
  return (
    <ActionMenu>
      <ActionMenu.Anchor>
        <Button
          size="small"
          className={styles.Button_0}
          aria-label={getBooleanValueLabel(filterBlock, index)}
          trailingVisual={() => <TriangleDownIcon className={styles.Octicon_0} />}
          {...testIdProps('afd-row-value-select-boolean-button')}
        >
          <ValuePlaceholder filterBlock={filterBlock} />
        </Button>
      </ActionMenu.Anchor>
      <ActionMenu.Overlay>
        <ActionList selectionVariant="single" {...testIdProps('afd-row-value-select-list')}>
          <ActionList.Item
            onSelect={() => setFilterValues(true)}
            selected={
              getFilterValue(filterBlock.value?.values[0]?.value) === undefined ||
              getFilterValue(filterBlock.value?.values[0]?.value) === 'true'
            }
          >
            True
          </ActionList.Item>
          <ActionList.Item
            onSelect={() => setFilterValues(false)}
            selected={getFilterValue(filterBlock.value?.values[0]?.value) === 'false'}
          >
            False
          </ActionList.Item>
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
